import { Routes } from '@angular/router';
import { BadGatewayComponent } from './shared/components/bad-gateway/bad-gateway.component';
import { NotFoundPageComponent } from './shared/components/not-found-page/not-found-page.component';
import { LoggedInGuard } from './core/guards/logged-in.guard';
import { NotLoggedInGuard } from './core/guards/not-logged-in.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'dashboard',
    pathMatch: 'full',
  },
  {
    path: 'auth',
    loadChildren: () => import('./auth/auth.module').then((m) => m.AuthModule),
    canActivate: [NotLoggedInGuard],
  },
  {
    path: 'dashboard',
    data: { breadcrumb: 'Dashboard' },
    loadChildren: () => import('./dashboard/dashboard.module').then((m) => m.DashboardModule),
    canActivate: [LoggedInGuard],
  },
  {
    path: 'employee-appointments/:employeeId',
    loadChildren: () =>
      import('./pages/employee-appointments-page/employee-appointments-page.module').then((m) => m.EmployeeAppointmentsPageModule),
    canActivate: [LoggedInGuard],
  },
  {
    path: 'employee-tasks/:employeeId',
    loadChildren: () => import('./pages/employee-tasks-page/employee-tasks-page.module').then((m) => m.EmployeeTasksPageModule),
    canActivate: [LoggedInGuard],
  },
  {
    path: 'book/appointment/:publicIdentifier',
    loadChildren: () =>
      import('./pages/iframe-booking-appointment-view-page/iframe-booking-appointment-view-page.module').then(
        (m) => m.IframeBookingAppointmentViewPageModule,
      ),
  },
  {
    path: 'book/:organizationId',
    loadChildren: () => import('./pages/iframe-booking-page/iframe-booking-page.module').then((m) => m.IframeBookingPageModule),
  },
  {
    path: 'booking-status/:organizationId',
    loadChildren: () =>
      import('./pages/iframe-booking-status-page/iframe-booking-status-page.module').then((m) => m.IframeBookingStatusPageModule),
  },
  {
    path: ':organizationId/gdpr',
    loadChildren: () => import('./pages/iframe-gdpr-page/iframe-gdpr-page.module').then((m) => m.IframeGdprPageModule),
  },
  {
    path: ':organizationId/terms-and-conditions',
    loadChildren: () =>
      import('./pages/iframe-terms-and-conditions-page/iframe-terms-and-conditions-page.module').then(
        (m) => m.IframeTermsAndConditionsPageModule,
      ),
  },
  {
    // MCP server consent page: an app asks to act as the signed-in user.
    path: 'oauth/authorize',
    loadComponent: () => import('./pages/oauth-authorize/oauth-authorize.component').then((m) => m.OAuthAuthorizeComponent),
    canActivate: [LoggedInGuard],
  },
  {
    path: 'maintenance',
    component: BadGatewayComponent,
  },
  {
    path: 'not-found',
    component: NotFoundPageComponent,
  },
  // Must stay last: it matches anything the routes above did not. Without it an
  // unknown address fails to match, the router falls back to '/' and renders
  // nothing, leaving a blank page with no way out.
  {
    path: '**',
    component: NotFoundPageComponent,
  },
];
